module.exports = __webpack_public_path__ + "static/media/22.0642d273.JPG";